import { toast } from "sonner";
import { Buildings } from "@phosphor-icons/react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n";

export const CompanySwitcher = () => {
  const { user } = useAuth();
  const { t } = useT();
  const mems = user?.memberships || [];
  if (mems.length < 2) return null;

  const switchTo = async (wsId) => {
    if (wsId === user.workspace_id) return;
    try {
      await api.post("/workspaces/switch", { workspace_id: wsId });
      window.location.reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="company-switcher">
      <Buildings size={16} className="text-slate-400" />
      <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-400 hidden sm:inline">{t("cs_label")}</span>
      <Select value={user.workspace_id} onValueChange={switchTo}>
        <SelectTrigger data-testid="company-switcher-trigger" className="rounded-none h-9 w-56 text-sm bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {mems.map((m) => (
            <SelectItem key={m.workspace_id} value={m.workspace_id} data-testid={`company-option-${m.workspace_id}`}>
              {m.workspace_name} · {m.workspace_type === "freelancer" ? t("cs_freelancer_tag") : t(`role_${m.role}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
